import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { paragraphPipe, FormatNumberPipe } from './string.helper';


@NgModule({
  declarations: [paragraphPipe, FormatNumberPipe],
  imports: [CommonModule],
  exports: [paragraphPipe, FormatNumberPipe],
})
export class MainPipe {}
